<!-- 轮播组件 -->
<template>
  <div
    class="web_swipe"
    :style="{
      padding: `${swiperOption.options.style ? swiperOption.options.style.padding +'px' : '0px'}`,
      borderRadius: `${swiperOption.options.style ? swiperOption.options.style.borderRadius +'px' : '0px'}`,
      backgroundColor: `${swiperOption.options.style ? swiperOption.options.style.bgColor : 'unset'}`,
    }"
  >
    <!-- 多张图片轮播 -->
    <van-swipe
      v-if="isSwiper"
      :autoplay="swiperOption.options.play.autoplay"
      :duration="swiperOption.options.play.duration"
      :loop="swiperOption.options.play.loop"
      :show-indicators="swiperOption.options.play.indicators"
      :indicator-color="swiperOption.options.play.indicatorColor"
      class="web_swipe_wrap"
    >
      <van-swipe-item
        v-for="image in swiperImages"
        :key="image.id"
      >
        <img
          class="web_swipe_img_item"
          :src="image.url"
        />
      </van-swipe-item>
    </van-swipe>
    <!-- 单张图片展示 -->
    <img
      v-else
      class="web_swipe_img"
      :src="swiperImages[0].url"
    />

    <!-- 开幕倒计时 -->
    <div
      v-if="countOption.show"
      class="web_swipe_countdown_wrap"
      :style="countOption.options.style.bgSty === 'sty1' ? `background:linear-gradient(to top, ${countOption.options.style.bgColor2}, ${countOption.options.style.bgColor1} )` : `background:linear-gradient(  ${countOption.options.style.bgColor2}, ${countOption.options.style.bgColor1} 50%,${countOption.options.style.bgColor2} )`"
    >
      <!-- sty1 -->
      <!-- background:linear-gradient(  ${option.countOption.style.top}, ${option.countOption.style.bottom} 50%,${option.countOption.style.top} ) -->
      <!-- sty2 -->
      <!-- background:linear-gradient(to top, ${option.countOption.style.bottom}, ${option.countOption.style.top} ) -->
      <div
        v-show="timer.length > 0"
        class="web_swipe_countdown"
        :style="`color: ${countOption.options.style.color}`"
      >
        {{ timer }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ObjectDeepClone, SimpleQicukSort } from '@a/js/utils'
import { Swipe, SwipeItem, } from 'vant'

Vue.use(Swipe)
Vue.use(SwipeItem)

export default {
  props: {
    swiperOption: {
      type: Object,
      default: () => { }
    },
    countOption: {
      type: Object,
      default: () => { }
    }
  },
  name: 'WebSwipe',
  data() {
    return {
      timer: '',
      Timer: null,
      isSwiper: false,
      swiperImages: [],

    }
  },

  watch: {
    swiperOption: {
      handler(data) {

        // 轮播
        if (!data.options.data.compatible) {
          this.swiperImages = SimpleQicukSort(ObjectDeepClone(data.options.data.common))
        } else {
          let height = this.getClientHeight()
          if (height <= 568) {
            this.swiperImages = SimpleQicukSort(ObjectDeepClone(data.options.data.small))
          } else if (height > 568 && height <= 667) {
            this.swiperImages = SimpleQicukSort(ObjectDeepClone(data.options.data.middle))
          } else if (height > 667) {
            this.swiperImages = SimpleQicukSort(ObjectDeepClone(data.options.data.large))
          }
        }
        if (this.swiperImages.length > 0) {
          this.isSwiper = true
        }
      },
      deep: true,
      immediate: true
    },
    countOption: {
      handler(values) {
        // 倒计时
        clearInterval(this.Timer)
        this.Timer = null
        if (values.show) {
          let timeDiff = values.options.data.endTime - values.options.data.startTime
          if (timeDiff > 0) {
            this.CountDownData(
              values.options.data.preText,
              timeDiff,
              this.getCountDowmFormat(values.options.data.content, values.options.data.format)
            )
          } else {
            this.$emit('listenHiddenCount')
          }
        }

      },
      deep: true,
      immediate: true
    }
  },

  components: {},

  methods: {
    /**
     * 自定义格式倒计时
     * @param preText 前置文字
     * @param alltime 时间差
     * @param format 格式数组
     */
    CountDownData(preText, alltime, format) {
      if (alltime > 0) {
        this.Timer = setInterval(() => {
          let scend = parseInt(format.minute.show ? alltime % 60 : alltime) //秒
          let minute = parseInt(format.hour.show ? (alltime / 60) % 60 : (alltime / 60)) //  分钟
          let hour = parseInt(format.day.show ? (alltime / 60 / 60) % 24 : (alltime / 60 / 60)) //小时
          let day = parseInt(format.month.show ? (alltime / 60 / 60 / 24) % 30 : (alltime / 60 / 60 / 24)) //天数
          // let month = parseInt((alltime / 2592000) % 12) //月
          let month = Math.floor(alltime / 2629744) //月
          if (month >= 0 && month <= 9) month = '0' + month
          if (day >= 0 && day <= 9) day = '0' + day
          if (hour >= 0 && hour <= 9) hour = '0' + hour
          if (minute >= 0 && minute <= 9) minute = '0' + minute
          if (scend >= 0 && scend <= 9) scend = '0' + scend

          let str = `${preText ? preText + ' ' : ''}${format.month.show ? month + ' ' + format.month.unit : ''} ${format.day.show ? day + ' ' + format.day.unit : ''} ${format.hour.show ? hour + ' ' + format.hour.unit : ''} ${format.minute.show ? minute + ' ' + format.minute.unit : ''} ${format.second.show ? scend + ' ' + format.second.unit : ''}`

          this.timer = str

          alltime--
          if (alltime < 0) {
            clearInterval(this.Timer)
            this.$emit('listenHiddenCount')
            return false
          }
        }, 1000)
      }

    },
    // 获取页面视口高度
    getClientHeight() {
      return document.documentElement.clientHeight
    },
    // 获取倒计时数据格式
    getCountDowmFormat(content, format) {
      let obj = {}
      content.map(item => {
        obj[item.id] = {
          name: item.id,
          label: item.label,
          unit: format[item.id],
          show: item.show
        }
      })
      return obj
    }
  },

  mounted() {

  },
}
</script>
<style lang="less" scoped>
.web_swipe {
  position: relative;
  width: 100%;
  font-size: 0px;
  box-sizing: border-box;
  .web_swipe_img {
    width: 100%;
  }
  .web_swipe_wrap {
    .web_swipe_img_item {
      width: 100%;
    }
  }
  // 倒计时
  .web_swipe_countdown_wrap {
    position: absolute;
    z-index: 98;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    box-sizing: border-box;
    .web_swipe_countdown {
      display: inline-block;
      font-size: 16px;
      padding: 10px 15px;
      box-sizing: border-box;
      line-height: 20px;
    }
  }
}
</style>
